import * as constants from '../constants';

export function setTopics(payload) {
  return {
    type: constants.SET_TOPICS,
    payload
  };
}
